<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Bank Payment Report</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
              (change)="onFinancialYearSlected()"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
          >Branch<span class="text-danger">*</span></label
        >
          <mat-form-field appearance="legacy" style="width: 50%">
            <mat-select
              multiple
              [(ngModel)]="selectedBranch"
              #designateBranch="ngModel"
              
            >
              <mat-option
                (click)="selectAllBranch(designateBranch, branchList)"
                [value]="0"
                >Select All
              </mat-option>
              <mat-option
                #item
                *ngFor="let branch of branchList"
                [value]="branch"
              >
                {{ branch.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedClosing"
            >
              <option value="">Select Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [value]="closing.id"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onViewReport()"
        >
          View Report
        </button>
      </div>
      <div class="col-sm-3" *ngIf="showExportToExcelButton">
        <button
          (click)="onExportToExcelReport()"
          class="btn btn-sm btn-block btn-outline-theme"
        >
          <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
        </button>
      </div>
    </div>
  </div>
</div>


  <div id="mainContent"
    class="container pt-4"
    *ngIf="bankPaymentList.length > 0">

  <div class="row justify-content-center text-center">
    <span class="bg-theme-title"
      >P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>
  
  <div class="row col-md-12 mt-2" *ngFor="let bankpayment of bankPaymentList">
    <div class="row ">
      <div class="col-sm-12">
        <label class="col-form-label"><b>Branch: </b>{{ bankpayment.branch }}</label>
      </div>
    </div>
      <table
        class="table table-bordered table-sm table-striped"
        style="display: block; overflow-x: auto; white-space: nowrap"
      >
        <thead>
          <tr>
            <th>Debit Ac. No.</th>
            <th>Beneficiary Ac. No.</th>
            <th>Beneficiary Name</th>
            <th>Designation</th>
            <th>Amount</th>
            <th>Pay Mod</th>
            <th>Date</th>
            <th>IFSC</th>
            <th>Payable Location</th>
            <th>Print Location</th>
            <th>Beneficiary Mobile No.</th>
            <th>Beneficiary Email ID</th>
            <th>Beneficiary add1</th>
            <th>Beneficiary add2</th>
            <th>Beneficiary add3</th>
            <th>Beneficiary add4</th>
            <th>Add Details 1</th>
            <th>Add Details 2</th>
            <th>Add Details 3</th>
            <th>Add Details 4</th>
            <th>Add Details 5</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody *ngFor="let data of bankpayment.bankStatementRests">
          <td>{{ data.debitAccountNumber }}</td>
          <td>{{ data.beneficiaryAccountNumber }}</td>
          <td>
            {{ data.firstName }} {{ data.middleName }} {{ data.lastName }}
          </td>
          <td>{{ data.designation == null ? "Article" : data.designation }}</td>
          <td>{{ data.amount }}</td>
          <td>{{ data.payMode }}</td>
          <td>{{ data.date }}</td>
          <td>{{ data.ifscCode }}</td>
          <td>{{ data.payableLocation }}</td>
          <td>{{ data.printLocation }}</td>
          <td>{{ data.mobileNo }}</td>
          <td>{{ data.email }}</td>
          <td>{{ data.beneficiaryAdd1 }}</td>
          <td>{{ data.beneficiaryAdd2 }}</td>
          <td>{{ data.beneficiaryAdd3 }}</td>
          <td>{{ data.beneficiaryAdd4 }}</td>
          <td>{{ data.addDetails1 }}</td>
          <td>{{ data.addDetails2 }}</td>
          <td>{{ data.addDetails3 }}</td>
          <td>{{ data.addDetails4 }}</td>
          <td>{{ data.addDetails5 }}</td>
          <td>{{ data.remarks }}</td>
        </tbody>
      </table>
    </div>
  </div>
</div>
